var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.0953 10.3249C17.0953 10.3702 16.74 14.864 16.5371 16.7553C16.41 17.9159 15.6618 18.6199 14.5395 18.6399C13.6771 18.6592 12.8329 18.6659 12.0024 18.6659C11.1206 18.6659 10.2583 18.6592 9.42123 18.6399C8.33651 18.6139 7.58765 17.8959 7.46705 16.7553C7.25827 14.8574 6.90945 10.3702 6.90297 10.3249C6.89648 10.1882 6.94057 10.0582 7.03005 9.95287C7.11823 9.85554 7.24531 9.79688 7.37887 9.79688H16.6259C16.7588 9.79688 16.8794 9.85554 16.9747 9.95287C17.0635 10.0582 17.1083 10.1882 17.0953 10.3249Z",
    fill: "#CE2600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 7.98327C18 7.70928 17.7841 7.49462 17.5247 7.49462H15.5809C15.1854 7.49462 14.8418 7.2133 14.7536 6.81665L14.6447 6.33066C14.4923 5.74335 13.9665 5.33203 13.3765 5.33203H10.6242C10.0277 5.33203 9.50702 5.74335 9.34882 6.36266L9.24703 6.81731C9.1582 7.2133 8.81457 7.49462 8.41971 7.49462H6.4759C6.21591 7.49462 6 7.70928 6 7.98327V8.2366C6 8.50392 6.21591 8.72525 6.4759 8.72525H17.5247C17.7841 8.72525 18 8.50392 18 8.2366V7.98327Z",
    fill: "#CE2600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteOutline);
export default __webpack_public_path__ + "static/media/delete-outline.b976072dfc092d8a230e60a26154e705.svg";
export { ForwardRef as ReactComponent };